import { TIPOS_DOCUMENTO } from '../dados/documentos';
import { CLAUSULAS_NA_BIBLIOTECA } from '../dados/numeros';
import { FeixeDocumentos } from './feixe-documentos';
import { Secao } from './secao';
import { Reveal, RevealGrupo } from './reveal';
import { Numero } from './numero';
import { MockClausula } from './mock-clausula';

/** O que sai da máquina: o feixe do estado para os três documentos, e o
 * trecho de cláusula renderizado — concordância e extenso batendo. */
export function Documentos(): JSX.Element {
  return (
    <Secao
      adiarRender
      alturaEstimada={1300}
      id="documentos"
      rotulo="Documentos"
      titulo={
        <>
          Três documentos, <span className="font-semibold">um</span> motor por trás dos
          três.
        </>
      }
      conduz={
        <>
          Toda geração sai em .docx editável e PDF, com{' '}
          <Numero
            valor={CLAUSULAS_NA_BIBLIOTECA}
            className="text-auth-texto-secundario text-base"
          />{' '}
          cláusulas versionadas na biblioteca — e o auditor roda sobre o próprio texto
          gerado, com <span className="text-auth-texto font-semibold">zero</span>{' '}
          apontamentos como único resultado aceito.
        </>
      }
    >
      {/* O feixe desce do nó "estado da sociedade" até o centro de cada uma
          das três colunas abaixo — por isso ele vem ANTES da grade e a grade
          perde o `mt-12` (o espaçamento agora é do desenho). */}
      <FeixeDocumentos />

      {/* `palco-3d` é a perspectiva compartilhada: sem ela no PAI, cada cartão
          teria a própria fuga e os três girariam em torno de eixos diferentes. */}
      <RevealGrupo
        className="palco-3d mt-12 grid gap-4 sm:mt-0 sm:grid-cols-3"
        passoMs={80}
      >
        {TIPOS_DOCUMENTO.map((tipo) => {
          const Icone = tipo.icone;
          return (
            <Reveal key={tipo.titulo} direcao="profundidade">
              <div className="border-auth-borda/8 rounded-auth-card cartao-reativo hover:border-auth-borda/20 hover:shadow-auth-profundidade flex h-full flex-col gap-2 border p-5">
                <Icone size={20} className="text-auth-marca-hover" aria-hidden />
                <h3 className="text-auth-texto text-base font-medium tracking-tight">
                  {tipo.titulo}
                </h3>
                <p className="text-auth-texto-secundario text-sm leading-relaxed">
                  {tipo.texto}
                </p>
              </div>
            </Reveal>
          );
        })}
      </RevealGrupo>

      {/* Um mock só, e é o da CLÁUSULA — concordância e valor por extenso
          batendo com o algarismo é o que nenhum Word entrega; o cartão de
          download que morava ao lado só repetia o que os três cartões acima
          já disseram. Corte aprovado pelo dono junto com o bloco do zero,
          que virou meia frase no conduz. */}
      <Reveal className="mx-auto mt-8 max-w-2xl">
        <MockClausula />
      </Reveal>
    </Secao>
  );
}
